module.exports = __webpack_public_path__ + "assets/img/img80.56f4f52e.png";